'use strict';

/* global angular */

import debounce from 'lodash/debounce';
import each from 'lodash/each';
import extend from 'lodash/extend';
import noop from 'lodash/noop';
import once from 'lodash/once';

angular.module('atex.aceui.ui').directive('aceuiContentEditor',
  ['$rootScope', '$timeout', '$compile', '$q', '$location', 'ErrorMessagingService', 'FileDeliveryService', 'TypeService', 'WidgetService',

    function ($rootScope, $timeout, $compile, $q, $location, ErrorMessagingService, FileDeliveryService, TypeService, WidgetService) {

      const COMPONENT_NAME = 'atex.aceui.ui.ContentEditor';

      var domainObjectService = atex.aceui.domain.DomainObjectService($q, FileDeliveryService);
      var factory = atex.aceui.domain.DomainObjectFactory($q, TypeService, domainObjectService);

      var createId = function (prefix) {
        var idPrefix = (typeof prefix !== 'undefined') ? prefix + '-' : '';
        return idPrefix + Math.round(Math.random() * 10000000).toString(16).substring(0, 5).toUpperCase();
      };

      var initializeViewIds = function (layout) {
        (layout.views || []).forEach(function (view) {
          view.id = createId('view');
          initializeViewIds(view);
        });
      };

      var initializeLayout = function (fieldBindings, layout, domainObject, templateId, mode, validationContext) {
        // Views

        (layout.views || []).forEach(function (view) {
          initializeView(fieldBindings, view, domainObject, templateId, mode, validationContext);
        });
      };

      var initializeView = function (fieldBindings, view, domainObject, templateId, mode, validationContext) {
        // Views

        var viewFields = [];

        (view.fields || []).forEach(function (viewField) {
          var field = fieldBindings.find(function (fieldBinding) {
            return fieldBinding.dataBinding.name === viewField;
          });

          if (typeof field !== 'undefined') {
            viewFields.push(extend(instantiateField(field, domainObject, templateId, mode, validationContext)));
          } else {
            console.warn('No data binding using the name "' + viewField + '" could be found, skipping...');
          }
        });

        view.fields = viewFields;

        (view.views || []).forEach(function (view) {
          initializeView(fieldBindings, view, domainObject, templateId, mode, validationContext);
        });

        // Rows

        (view.rows || []).forEach(function (row) {
          initializeRow(fieldBindings, row, domainObject, templateId, mode, validationContext);
        });
      };

      var initializeRow = function (fieldBindings, row, domainObject, templateId, mode, validationContext) {
        // Columns

        (row.columns || []).forEach(function (column) {
          initializeColumn(fieldBindings, column, domainObject, templateId, mode, validationContext);
        });
      };

      var initializeColumn = function (fieldBindings, column, domainObject, templateId, mode, validationContext) {
        // Columns

        var columnFields = [];

        (column.fields || []).forEach(function (columnField) {
          var field = fieldBindings.find(function (fieldBinding) {
            return fieldBinding.dataBinding.name === columnField;
          });

          if (typeof field !== 'undefined') {
            columnFields.push(extend(instantiateField(field, domainObject, templateId, mode, validationContext)));
          } else {
            console.warn('No data binding using the name "' + columnField + '" could be found, skipping...');
          }
        });

        column.fields = columnFields;

        (column.groups || []).forEach(function (group) {
          initializeGroup(fieldBindings, group, domainObject, templateId, mode, validationContext);
        });

        (column.rows || []).forEach(function (row) {
          initializeRow(fieldBindings, row, domainObject, templateId, mode, validationContext);
        });
      };

      var initializeGroup = function (fieldBindings, group, domainObject, templateId, mode, validationContext) {
        var groupFields = [];

        (group.fields || []).forEach(function (groupField) {
          var field = fieldBindings.find(function (fieldBinding) {
            return fieldBinding.dataBinding.name === groupField;
          });

          if (typeof field !== 'undefined') {
            groupFields.push(extend(instantiateField(field, domainObject, templateId, mode, validationContext)));
          } else {
            console.warn('No data binding using the name "' + groupField + '" could be found, skipping...');
          }
        });

        group.fields = groupFields;
      };

      var instantiateField = function (fieldBinding, domainObjectTree, templateId, mode, validationContext) {
        var widgetId = createId('widget');

        var fieldDomainObjects = {};
        var singleFieldDomainObject = undefined;

        if (typeof fieldBinding.dataBinding.domainObjects !== 'undefined'
          && typeof fieldBinding.dataBinding.domainObject !== 'undefined')
        {
          throw atex.aceui.error.Error({
            cause: 'Error reading template "' + templateId + '": '
            + 'dataBinding for "' + fieldBinding.dataBinding.widget + '" contains both "domainObject" and "domainObjects".',
            origin: COMPONENT_NAME,
            severity: atex.aceui.error.severities.MAJOR,
            type: atex.aceui.error.types.INVALID_PARAMETERS
          });
        }

        if (typeof fieldBinding.dataBinding.domainObjects !== 'undefined') {
          var shortDomainObjectPaths = JSON.parse(JSON.stringify(fieldBinding.dataBinding.domainObjects));

          Object.keys(shortDomainObjectPaths).forEach(function (domainObjectKey) {
            if (shortDomainObjectPaths[domainObjectKey][0] !== '/') {
              shortDomainObjectPaths[domainObjectKey] = ['/', 'aspects'].concat(atex.aceui.ObjectUtils.toPathArray(shortDomainObjectPaths[domainObjectKey]));
            }
          });

          var domos = atex.aceui.DomainObjectUtils.getMultipleDomainObjectsByPath(domainObjectTree, shortDomainObjectPaths);

          each(domos, function (domo, key) {
            fieldDomainObjects[key] = atex.aceui.DomainObjectUtils.getProxyFor(domo, widgetId);
          });
        }

        if (typeof fieldBinding.dataBinding.domainObject !== 'undefined') {
          var shortDomainObjectPath = JSON.parse(JSON.stringify(fieldBinding.dataBinding.domainObject));

          if (shortDomainObjectPath !== '/') {
            shortDomainObjectPath = ['/', 'aspects'].concat(atex.aceui.ObjectUtils.toPathArray(shortDomainObjectPath));
          }

          var domainObject = atex.aceui.DomainObjectUtils.getDomainObjectByPath(domainObjectTree, shortDomainObjectPath);
          singleFieldDomainObject = atex.aceui.DomainObjectUtils.getProxyFor(domainObject, widgetId);
        }

        var field = JSON.parse(JSON.stringify(fieldBinding));

        field.widgetId = widgetId;
        field.mode = mode;
        field.domainObject = singleFieldDomainObject;
        field.domainObjects = fieldDomainObjects;
        field.validationContext = validationContext;

        return field;
      };

      var loadDataBinding = function (dataBinding) {
        if (typeof dataBinding.widget === 'undefined') {
          console.warn('No widget defined for field "' + (dataBinding.name || '[anonymous field]') + '", skipping...');
          return $q.when();
        }

        var bundleId = dataBinding.widget.split('/')[0];
        var widgetName = dataBinding.widget.split('/')[1] || dataBinding.widget;

        return WidgetService.getWidget(widgetName, bundleId).then(function (widget) {
          var directiveNameDashed = widget.directiveName.replace(/\W+/g, '-').replace(/([a-z\d])([A-Z])/g, '$1-$2').replace(/([A-Z])(?=[A-Z])/g, '$1-').toLowerCase();

          return FileDeliveryService.getContentVersionBaseUrl(widget.widgetContentVersion).then(function (baseUrl) {
            return {
              baseUrl: baseUrl,
              dataBinding: dataBinding,

              widgetNameDashed: directiveNameDashed
            };
          });
        }, function (error) {
          var fieldError = atex.aceui.error.Error({
            rootCause: error,
            cause: 'Error loading widget "' + dataBinding.widget + '": ' + error.cause,
            origin: COMPONENT_NAME,
            severity: atex.aceui.error.severities.MAJOR
          });

          console.error('ERROR:', fieldError);
          return $q.reject(fieldError);
        });
      };

      return {
        transclude: true,
        restrict: 'E',

        scope: {
          content: '<',
          template: '<',
          activeViewMap: '=?',

          changeEndDelay: '&',

          changeStartCallback: '&',
          changeEndCallback: '&',

          loadCallback: '&',
          initCallback: '&',
          editCallback: '&',

          errorCallback: '&',

          updateActiveViewCallback: '&',
          isActiveViewCallback: '&',

          validationContext: '<',

          mode: '<?'
        },

        controller: function ($scope) {
          $scope.$emit('content-editor:initialize');

          $scope.changeEndDelay = $scope.changeEndDelay() || 500;

          $scope.changeStartCallback = $scope.changeStartCallback();
          $scope.changeEndCallback = $scope.changeEndCallback();

          $scope.errorCallback = $scope.errorCallback() || noop;
          $scope.loadCallback = $scope.loadCallback() || noop;
          $scope.initCallback = $scope.initCallback() || noop;
          $scope.editCallback = $scope.editCallback() || noop;

          $scope.updateActiveViewCallback = $scope.updateActiveViewCallback();
          $scope.isActiveViewCallback = $scope.isActiveViewCallback();

          $scope.activeViewMap = {};
          $scope.activeViewMap[0] = 0;

          $scope.mode = $scope.mode || 'edit';

          $scope.fields = [];
          $scope.layout = {};

          $scope.$on('$destroy', function () {
            $scope.destroyed = true;

            if (typeof $scope.changeFinalizer !== 'undefined') {
              $scope.changeFinalizer();
            }

            if (typeof $scope.topDomainObject !== 'undefined') {
              $scope.topDomainObject.destroy();
            }

            if (typeof $scope.errorFinalizer !== 'undefined') {
              $scope.errorFinalizer();
            }

            $scope.$emit('content-editor:destroyed');
          });
        },

        link: function (scope, element, attrs, ctrl, transclude) {
          scope.initCallback();
          scope.$emit('content-editor:initialized');

          var templateLayout = atex.aceui.ObjectUtils.getByPath(scope, 'template/layout') || {};
          scope.layout = JSON.parse(JSON.stringify(templateLayout));

          initializeViewIds(scope.layout);

          $timeout(function () {
            var domainObjectData = {
              aspects: extend({ }, scope.content.aspects),
              system: { contentType: scope.content.system.contentType || scope.template.type },
              operations: scope.content.operations || []
            };

            factory.fromData(domainObjectData, scope.template).then(function (domainObject) {
              scope.topDomainObject = domainObject;

              return $q.when(scope.editCallback(domainObject)).then(function () {
                scope.$emit('content-editor:domain-object-ready', domainObject);

                var promises = scope.template.dataBindings.map(function (dataBinding) {
                  return loadDataBinding(dataBinding);
                });

                return $q.all(promises).then(function (fieldBindings) {
                  var filteredFieldBindings = fieldBindings.filter(function (fieldBinding) {
                    return typeof fieldBinding !== 'undefined';
                  });

                  scope.fields = filteredFieldBindings.map(function (fieldBinding) {
                    return instantiateField(fieldBinding, domainObject, scope.template.id, scope.mode, scope.validationContext);
                  });

                  initializeLayout(filteredFieldBindings, scope.layout, domainObject, scope.template.id, scope.mode, scope.validationContext);

                  transclude(scope, function (clone) {
                    element.empty().append(clone);
                    element.addClass('content-editor');
                  });

                  var createStartFn = function () {
                    if (typeof scope.changeStartCallback !== 'undefined') {
                      return once(scope.changeStartCallback);
                    }
                    return noop;
                  };

                  var createEndFn = function () {
                    return debounce(function () {
                      changeStartFn = createStartFn();
                      var dataShuttle = domainObject.pack();

                      scope.changeEndCallback && scope.changeEndCallback(dataShuttle);

                      scope.$apply(function () {
                        scope.$emit('content-editor:changed', dataShuttle);
                      });
                    }, scope.changeEndDelay);
                  };

                  var changeStartFn = createStartFn();
                  var changeEndFn = createEndFn();

                  scope.errorFinalizer = domainObject.on('aceui:error', function (event, error) {
                    scope.errorCallback(error);
                    scope.$emit('content-editor:error', error);
                  });

                  scope.changeFinalizer = domainObject.on('aceui:changed', function () {
                    changeStartFn();
                    changeEndFn();
                  });
                });
              });
            }).then(function () {
              var context = JSON.parse(JSON.stringify({ 'fields': scope.fields, 'layout': scope.layout }));

              scope.loadCallback(context);
              scope.$emit('content-editor:loaded', context);
            }).catch(function (error) {
              if (error.origin === COMPONENT_NAME) {
                ErrorMessagingService.sendError(error);
              } else {
                ErrorMessagingService.sendError(atex.aceui.error.Error({
                  rootCause: error,
                  origin: COMPONENT_NAME,
                  cause: 'There was an error when displaying content',
                  severity: atex.aceui.error.severities.CRITICAL,
                  type: atex.aceui.error.types.RUNTIME
                }));
              }
            });
          });
        }
      };
    }
  ]);
